import { object, string, array, number } from "yup";
import featureSchema from "../feature/schema";

export default object()
  .required()
  .noUnknown()
  .shape({
    features: array().of(featureSchema)
  });
